import React from "react"
import Label from "@kit/design/label"
import Input from "@kit/design/input"
import { ColorInput } from "@kit/design/color-picker"
import { useBlocks } from "app/regions/hooks/use-blocks"
import { Padding } from "app/regions/blocks/section/utils/padding"
import { Margin } from "app/regions/blocks/section/utils/margin"
import { ColumnRatio } from "../../components/column-ratio"
import { BlocksImageUploader } from "app/regions/blocks/shared/blocks-image-uploader"
import { Expander } from "app/regions/blocks/shared/expander"
import { BackgroundColor } from "../../components/background-color"
import { BorderSettings } from "../../components/border-settings"
import { useSavedColors } from "hooks/use-saved-colors"

export function CTALeftHeaderImageRightSettings({ block_id }) {
  const { properties, update } = useBlocks(block_id)
  const savedColors = useSavedColors()

  return (
    <>
      <div className="mb-4">
        <BlocksImageUploader
          className="h-40"
          label="Image"
          name="image"
          image={properties.image}
          alt={properties.alt}
          update={file =>
            update({
              image: file.image || properties.image,
              alt: file.alt
            })
          }
          remove={() => update({ image: "", alt: "" })}
        />
      </div>

      <div className="mb-4">
        <Label htmlFor="imageUrl">Image URL</Label>
        <Input
          className="text-gray-700 mb-1 w-full"
          placeholder="https://example.com"
          name="imageUrl"
          onChange={e => update({ imageUrl: e.target.value })}
          value={properties.imageUrl || ""}
        />
      </div>

      <Expander label="Spacing">
        <div>
          <ColumnRatio properties={properties} update={update} />
        </div>

        <div className="mb-4">
          <Padding properties={properties} update={update} />
        </div>

        <div className="mb-4">
          <Margin properties={properties} update={update} />
        </div>
      </Expander>

      <Expander label="Colors">
        <BackgroundColor properties={properties} update={update} />

        <div>
          <Label htmlFor="textColor">Heading</Label>
          <ColorInput
            id="headingColor"
            name="headingColor"
            onChange={color => update({ headingColor: color.hex })}
            value={properties.headingColor}
            savedColors={savedColors}
          />
        </div>
      </Expander>

      <BorderSettings properties={properties} update={update} />
    </>
  )
}
